function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#B8C8CC"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.48 6.268c.535-.548 1.434-.2 1.514.538l.006.108v10.172c0 .773-.875 1.182-1.441.718l-.079-.072-2.924-2.996H4.889c-.451 0-.827-.349-.882-.796L4 13.826v-3.643c0-.462.34-.847.778-.903l.11-.007h2.668l2.924-3.005zm4.557-2.21C17.943 5.278 20 8.37 20 12.002c0 3.631-2.057 6.724-4.963 7.944-.466.195-.97-.159-1.03-.695l-.007-.11v-.188c0-.36.206-.672.514-.804 2.212-.974 3.772-3.367 3.772-6.147 0-2.78-1.56-5.173-3.772-6.147-.266-.118-.465-.378-.506-.686L14 5.05v-.19c0-.595.54-1.02 1.037-.803zM14 7c1.776.92 3 2.807 3 5.006 0 2.114-1.132 3.941-2.798 4.885L14 17V7z"
})));

var SvgVolume = function SvgVolume(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVolume, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volume.d76316db.svg";
export { ForwardRef as ReactComponent };